import { CustomizedPaper } from "~/components/atomic/index";

import { ProfileHelp } from "~/components/ProfileHelp";

export function PatientAccountHelp() {
  return (
      <CustomizedPaper>
        <ProfileHelp />
      </CustomizedPaper>
  )
}
